<template>
  <div id="sna-page">
    <alert-dynamic-component v-if="is_error" :type="'warning'" :title="alert.title" :subtitle="alert.subtitle"
      :closeNotif="closeNotif" class="m-b-10 mx-2" />
    <page-header-component v-if="topics" :topics="topics" @filterChange="filterChange" icon="bi bi-bezier2"
      title="Social Network Analytic (SNA)" isType="medsos" :is_sna="true" :hideValidate="true" :hideTopik="false" />
    <div class="row">
      <div class="col-md-12 sna-container px-gap" v-if="is_sna">
        <div id="network" class="network-wrapper">
          <loader-component v-if="is_loading" />
          <div v-else>
            <div class="row">
              <div class="col-md-8" id="network_container">
                <div class="bg-black d-flex justify-content-end align-items-center"
                  style="height: 10vh;border-top-right-radius: 8px;border-top-left-radius: 8px">
                  <!-- <img src="../../../../public/assets/img/logo.png" alt="logo" class="brand" height="30"
                    style="max-width: 100%; margin-right:0.75rem" />
                  <img src="../../../../public/assets/img/logo_au.png" alt="logo" class="brand" height="30"
                    style="max-width: 100%; margin-right: 0.75rem;" /> -->
                </div>
                <Network class="network w-100 rounded shade" ref="network" :nodes="nodes" :edges="edges"
                  :options="options" :events="['click']" @click="onModalShow"
                  style="background-color: black; height: 90vh;border-top-right-radius: 0 !important;border-top-left-radius: 0 !important;box-shadow: none !important">
                </Network>
              </div>
              <div class="col-md-4 pr-1 pl-3" id="config-manual">
                <div class="bg-white rounded p-3 shade">
                  <span class="h6 font-weight-bolder">
                    Konfigurasi Manual:
                  </span>
                  <div class="d-flex align-items-center">
                    <div class="form-check mt-3">
                      <input class="form-check-input" type="checkbox" id="physics"
                        v-model.number="options.physics.enabled" />
                      <label class="form-check-label small" for="physics">
                        Mainkan Animasi
                      </label>
                    </div>
                    <button class="ml-auto btn btn-sm btn-warning h-50" style="width: 5.5rem" @click="setFullScreen">
                      Full Screen
                    </button>
                    <button class="ml-2 btn btn-sm btn-warning h-50" style="width: 20%" @click="resetOption">
                      Reset
                    </button>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="range-2" class="mr-2 w-50 small">
                      Konstanta Gravitasi
                    </label>
                    <b-form-input v-if="options.physics.solver == 'forceAtlas2Based'" id="range-2" v-model.number="options.physics.forceAtlas2Based.gravitationalConstant
                      " type="range" min="-500" max="0" step="0.1"></b-form-input>

                    <b-form-input v-else id="range-2" v-model.number="options.physics.barnesHut.gravitationalConstant
                      " type="range" min="-500" max="0" step="0.1"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      <span v-if="options.physics.solver == 'forceAtlas2Based'">
                        {{
                          options.physics.forceAtlas2Based.gravitationalConstant
                        }}
                      </span>
                      <span v-else>
                        {{ options.physics.barnesHut.gravitationalConstant }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="range-2" class="mr-2 w-50 small">
                      Gravitasi Pusat
                    </label>
                    <b-form-input v-if="options.physics.solver == 'forceAtlas2Based'" id="range-2" v-model.number="options.physics.forceAtlas2Based.centralGravity
                      " type="range" min="0" max="10" step="0.1"></b-form-input>
                    <b-form-input v-else id="range-2" v-model.number="options.physics.barnesHut.centralGravity"
                      type="range" min="0" max="10" step="0.1"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      <span v-if="options.physics.solver == 'forceAtlas2Based'">
                        {{ options.physics.forceAtlas2Based.centralGravity }}
                      </span>
                      <span v-else>
                        {{ options.physics.barnesHut.centralGravity }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="range-2" class="mr-2 w-50 small">
                      Panjang Musim Semi
                    </label>
                    <b-form-input v-if="options.physics.solver == 'forceAtlas2Based'" id="range-2" v-model.number="options.physics.forceAtlas2Based.springLength
                      " type="range" min="0" max="500" step="1"></b-form-input>
                    <b-form-input v-else id="range-2" v-model.number="options.physics.barnesHut.springLength"
                      type="range" min="0" max="500" step="1"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      <span v-if="options.physics.solver == 'forceAtlas2Based'">
                        {{ options.physics.forceAtlas2Based.springLength }}
                      </span>
                      <span v-else>
                        {{ options.physics.barnesHut.springLength }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="range-2" class="mr-2 w-50 small">
                      Konstanta Musim Semi
                    </label>
                    <b-form-input v-if="options.physics.solver == 'forceAtlas2Based'" id="range-2" v-model.number="options.physics.forceAtlas2Based.springConstant
                      " type="range" min="0" max="1.2" step="0.01"></b-form-input>
                    <b-form-input v-else id="range-2" v-model.number="options.physics.barnesHut.springConstant"
                      type="range" min="0" max="1.2" step="0.01"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      <span v-if="options.physics.solver == 'forceAtlas2Based'">
                        {{ options.physics.forceAtlas2Based.springConstant }}
                      </span>
                      <span v-else>
                        {{ options.physics.barnesHut.springConstant }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center small">
                    <label for="range-2" class="mr-2 w-50">Pembasahan</label>
                    <b-form-input v-if="options.physics.solver == 'forceAtlas2Based'" id="range-2"
                      v-model.number="options.physics.forceAtlas2Based.damping" type="range" min="0" max="1"
                      step="0.01"></b-form-input>
                    <b-form-input v-else id="range-2" v-model.number="options.physics.barnesHut.damping" type="range"
                      min="0" max="1" step="0.01"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      <span v-if="options.physics.solver == 'forceAtlas2Based'">
                        {{ options.physics.forceAtlas2Based.damping }}
                      </span>
                      <span v-else>
                        {{ options.physics.barnesHut.damping }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="range-2" class="mr-2 w-50 small">
                      Hindari Tumpang Tindih
                    </label>
                    <b-form-input v-if="options.physics.solver == 'forceAtlas2Based'" id="range-2" v-model.number="options.physics.forceAtlas2Based.avoidOverlap
                      " type="range" min="0" max="1" step="0.01"></b-form-input>
                    <b-form-input v-else id="range-2" v-model.number="options.physics.barnesHut.avoidOverlap"
                      type="range" min="0" max="1" step="0.01"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      <span v-if="options.physics.solver == 'forceAtlas2Based'">
                        {{ options.physics.forceAtlas2Based.avoidOverlap }}
                      </span>
                      <span v-else>
                        {{ options.physics.barnesHut.avoidOverlap }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="range-2" class="mr-2 w-50 small">
                      Kecepatan Min
                    </label>
                    <b-form-input id="range-2" v-model.number="options.physics.minVelocity" type="range" min="0" max="1"
                      step="0.01"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      {{ options.physics.minVelocity }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="range-2" class="mr-2 w-50 small">
                      Kecepatan Max
                    </label>
                    <b-form-input id="range-2" v-model.number="options.physics.maxVelocity" type="range" min="0"
                      max="150" step="1"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      {{ options.physics.maxVelocity }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <label for="range-2" class="mr-2 w-50 small">
                      Langkah Waktu
                    </label>
                    <b-form-input id="range-2" v-model.number="options.physics.timestep" type="range" min="0" max="1"
                      step="0.01"></b-form-input>
                    <div class="border rounded px-1 ml-2 text-center" style="width: 20%">
                      {{ options.physics.timestep }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center mb-3">
                    <label for="solver" class="mr-4 w-25 mt-1 small">
                      Pemecah
                    </label>
                    <select name="solver" id="solver" class="form-control-sm small form-custom"
                      v-model="options.physics.solver">
                      <option value="barnesHut">barnesHut</option>
                      <option value="forceAtlas2Based">forceAtlas2Based</option>
                    </select>
                  </div>
                </div>
                <div class="btn-group mt-2" role="group">
                  <button type="button" class="btn" :class="is_bantuan ? 'btn-light' : 'btn-warning'"
                    @click="is_bantuan = false">
                    Tips Penggunaan
                  </button>
                  <button type="button" class="btn" :class="is_bantuan ? 'btn-warning' : 'btn-light'"
                    @click="is_bantuan = true">
                    Bantuan
                  </button>
                </div>
                <div class="mt-2 card p-2 rounded shade" v-if="is_bantuan == true">
                  <ul class="pl-3">
                    <li class="small text-justify">
                      <strong>"Mainkan Animasi"</strong> membuat graph bergerak.
                    </li>
                    <li class="small text-justify">
                      <strong>"Konstanta Gravitasi"</strong> mempengaruhi
                      kekuatan tarik menarik node.
                    </li>
                    <li class="small text-justify">
                      <strong>"Gravitasi Pusat"</strong> membuat node semakin
                      terpusat ke tengah.
                    </li>
                    <li class="small text-justify">
                      <strong>"Panjang Musim Semi"</strong> berfungsi untuk mengatur
                      panjang pegas.
                    </li>
                    <li class="small text-justify">
                      <strong>"Konstanta Musim Semi"</strong> mempengaruhi kekuatan
                      pegas untuk menarik node.
                    </li>
                    <li class="small text-justify">
                      <strong>"Pembasahan"</strong> berfungsi untuk meredam dari
                      banyaknya kecepatan.
                    </li>
                    <li class="small text-justify">
                      <strong>"Hindari Tumpang Tindih"</strong> berfungsi untuk
                      menghindari tumpukkan node.
                    </li>
                    <li class="small text-justify">
                      <strong>"Kecepatan Min"</strong> berfungsi untuk membatasi
                      minimum waktu proses stabilisasi.
                    </li>
                    <li class="small text-justify">
                      <strong>"Kecepatan Max"</strong> berfungsi untuk membatasi
                      maksimum waktu proses stabilisasi.
                    </li>
                    <li class="small text-justify">
                      <strong>"Langkah Waktu"</strong> mempengaruhi kecepatan
                      pergerakan node.
                    </li>
                    <li class="small text-justify">
                      Solver <strong>"Barneshut"</strong> untuk membuat layout
                      sesuai dengan keterkaitan node (Akun).
                    </li>
                    <li class="small text-justify">
                      Solver <strong>"forceAtlas2Based"</strong> untuk membuat
                      layout berbentuk atlas/bola dunia.
                    </li>
                  </ul>
                </div>
                <div class="mt-2 card p-2 rounded shade" v-else>
                  <ul class="pl-3">
                    <li class="small text-justify">
                      Pilih Pemecah sesuai kebutuhan.
                    </li>
                    <li class="small text-justify">
                      Naikan Langkah Waktu menjadi 1.
                    </li>
                    <li class="small text-justify">
                      Centang Mainkan Animasi untuk membentuk layout.
                    </li>
                    <li class="small text-justify">
                      Hapus Centang Mainkan Animasi ketika layout dirasa sudah
                      cukup sesuai.
                    </li>
                    <li class="small text-justify">
                      Klik pada node untuk melihat postingan.
                    </li>
                  </ul>
                </div>
                <div class="clearfix" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-else>
        <div class="subscribe-now bg-white p-t-10 p-l-10 p-b-5 shade">
          <p>Silahkan hubungi administrator untuk membuka fitur ini.</p>
        </div>
      </div>
    </div>
    <!-- modal account post component -->
    <modal-account-post-component v-if="isShowModal" :id_account="id_account" :key="modal_key" @close="onModalClose" />
    <!-- tour component -->
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import modal_account_post from "@/views/components/sna/modal_account_post.vue";
import alert_dynamic from "@/views/components/alert_dynamic.vue";
import loader from "@/views/components/loader.vue";
import { Network } from "vue-vis-network";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

export default {
  name: "SNA",
  title: "Analitik SNA | Sibernetik",
  components: {
    "page-header-component": page_header,
    "loader-component": loader,
    "modal-account-post-component": modal_account_post,
    "alert-dynamic-component": alert_dynamic,
    Network,
  },
  data() {
    return {
      modal_key: 0,
      id_account: null,
      isShowModal: false,
      is_bantuan: false,
      tour_steps: [],
      id_project: this.$store.getters.user.id_project,
      filter_topic: this.$store.getters.filter_topic_sna,
      is_loading: true,
      graph_key: 0,
      topics: null,
      is_sna: this.$store.getters.user.project.project_detail.sna
        ? true
        : false,
      nodes: null,
      edges: null,
      options: {
        layout: {
          improvedLayout: false,
        },
        interaction: {
          hover: true,
        },
        physics: {
          enabled: false,
          forceAtlas2Based: {
            gravitationalConstant: -50,
            centralGravity: 0.01,
            springLength: 100,
            springConstant: 0.08,
            damping: 0.4,
            avoidOverlap: 0,
          },
          barnesHut: {
            gravitationalConstant: -2000,
            centralGravity: 0.3,
            springLength: 95,
            springConstant: 0.04,
            damping: 0.09,
            avoidOverlap: 0,
          },
          minVelocity: 0.75,
          maxVelocity: 50,
          solver: "forceAtlas2Based",
          timestep: 0.5,
        },
      },
      is_error: false,
      alert: {
        title: "",
        subtitle: "",
      },
    };
  },
  methods: {
    getData: function () {
      this.is_loading = true;
      if (this.cancelToken) {
        this.cancelToken.cancel("Cancel request sebelumnya.");
      }
      this.cancelToken = this.$http.CancelToken.source();

      let params = {};

      params = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };

      if ("topic_selected" in this.$route.query) {
        params.topic_selected = this.$route.query.topic_selected;
      } else {
        if (this.filter_topic) {
          if (this.filter_topic.tipe == "topik") {
            params.topic = this.filter_topic.id;
          } else if (this.filter_topic.tipe == "group") {
            params.group = this.filter_topic.id;
          }
        }
      }
      if ("cakupan" in this.$route.query) {
        params.cakupan = this.$route.query.cakupan;
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query) {
        let api =
          process.env.VUE_APP_API_URL +
          "sna-nodes-links/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api, { cancelToken: this.cancelToken.token })
          .then((response) => {
            if (response.status == 200) {
              this.nodes = response.data.sna_nodes;
              this.edges = response.data.sna_links;
            }
          })
          .catch((err) => {
            this.is_error = true;
            if (
              err.response &&
              (err.response.status == 500 ||
                err.response.status == 400 ||
                err.response.status == 404)
            ) {
              this.alert.title = "Perhatian!";
              this.alert.subtitle =
                "Data gagal dimuat. Silahkan untuk mencoba lagi.";
            } else {
              this.alert.title = "Perhatian!";
              this.alert.subtitle =
                "Sistem tidak dapat menampilkan data yang diminta. Silahkan gunakan rentang waktu lebih pendek.";
            }
          })
          .finally(() => {
            this.is_loading = false;
          });
      }
    },
    generateGraph: function () {
      this.graph_key++;
    },
    filterChange: function () {
      this.edges = null;
      this.nodes = null;
      this.getData();
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data;
          } else {
            this.topics = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.filterChange();
        });
    },
    compare: function (a, b) {
      if (a.tipe > b.tipe) {
        return -1;
      }
      if (a.tipe < b.tipe) {
        return 1;
      }
      return 0;
    },
    resetOption: function () {
      this.options = {
        layout: {
          improvedLayout: false,
        },
        physics: {
          enabled: false,
          forceAtlas2Based: {
            gravitationalConstant: -50,
            centralGravity: 0.01,
            springLength: 100,
            springConstant: 0.08,
            damping: 0.4,
            avoidOverlap: 0,
          },
          barnesHut: {
            gravitationalConstant: -2000,
            centralGravity: 0.3,
            springLength: 95,
            springConstant: 0.04,
            damping: 0.09,
            avoidOverlap: 0,
          },
          minVelocity: 0.75,
          maxVelocity: 50,
          solver: "forceAtlas2Based",
          timestep: 0.5,
        },
      };
    },
    onModalShow: function (event) {
      if (!document.fullscreenElement) {
        this.id_account = event.nodes[0];
        if (this.id_account) {
          this.modal_key++;
          this.isShowModal = true;
        }
      }
    },
    onModalClose: function () {
      this.isShowModal = false;
    },
    closeNotif: function () {
      this.is_error = false;
    },
    setFullScreen: function () {
      let network_container = document.getElementById('network_container');

      if (!document.fullscreenElement) {
        network_container.requestFullscreen();
      }
    },
  },
  watch: {
    edges() {
      if (this.edges && this.nodes) {
        this.generateGraph();
      }
    },
    nodes() {
      if (this.edges && this.nodes) {
        this.generateGraph();
      }
    },
  },
  created: function () {
    this.getTopic();
  },
  mounted: function () {
    let v_step = [];
    v_step[0] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#network",
      header: {
        title: "Grafik Network",
      },
      content: `Menampilkan grafik social network Positif, Netral, Negatif dan Retweeter.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#config-manual",
      header: {
        title: "Konfigurasi Manual",
      },
      content: `Digunakan untuk mengatur grafik dari SNA secara manual.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>


<style>
  .vis-tooltip{
    font-size: 12px;
  }

</style>
